export class AtrybutyUszkodzen {

  constructor(public pokazSzerokosc: boolean = false,
              public pokazWysokosc: boolean = false,
              public pokazWartosc: boolean = true,
              public pokazKomentarz: boolean = false,
              public etykietaWartosci: string = '',
              public pokazMaterialyWykonczenia: boolean = false,
              public pokazRodzajePowierzchni: boolean = false,
              public pokazFolieReklamowa: boolean = false) {
  }

  static Builder = class {
    private readonly atrybuty: AtrybutyUszkodzen;

    constructor() {
      this.atrybuty = new AtrybutyUszkodzen();
    }

    pokazSzerokosc(pokazSzerokosc: boolean): this {
      this.atrybuty.pokazSzerokosc = pokazSzerokosc;
      return this;
    }

    pokazWysokosc(pokazWysokosc: boolean): this {
      this.atrybuty.pokazWysokosc = pokazWysokosc;
      return this;
    }

    pokazWartosc(pokazWartosc: boolean): this {
      this.atrybuty.pokazWartosc = pokazWartosc;
      return this;
    }

    pokazKomentarz(pokazKomentarz: boolean): this {
      this.atrybuty.pokazKomentarz = pokazKomentarz;
      return this;
    }

    etykietaWartosci(etykietaWartosci: string): this {
      this.atrybuty.etykietaWartosci = etykietaWartosci;
      return this;
    }

    pokazMaterialyWykonczenia(pokazMaterialyWykonczenia: boolean): this {
      this.atrybuty.pokazMaterialyWykonczenia = pokazMaterialyWykonczenia;
      return this;
    }

    pokazRodzajePowierzchni(pokazRodzajePowierzchni: boolean): this {
      this.atrybuty.pokazRodzajePowierzchni = pokazRodzajePowierzchni;
      return this;
    }

    pokazFolieReklamowa(pokazFolieReklamowa: boolean): this {
      this.atrybuty.pokazFolieReklamowa = pokazFolieReklamowa;
      return this;
    }

    build(): AtrybutyUszkodzen {
      return this.atrybuty;
    }

  }
}
